var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTestAcca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3334 9.33325H11.6667C10.378 9.33325 9.33337 10.3779 9.33337 11.6666V47.8333C9.33337 49.1219 10.378 50.1666 11.6667 50.1666H44.3334C45.622 50.1666 46.6667 49.1219 46.6667 47.8333V11.6666C46.6667 10.3779 45.622 9.33325 44.3334 9.33325Z",
    fill: "#15C480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 5.83325H21C20.3557 5.83325 19.8334 6.35559 19.8334 6.99992V11.6666C19.8334 12.3109 20.3557 12.8333 21 12.8333H35C35.6444 12.8333 36.1667 12.3109 36.1667 11.6666V6.99992C36.1667 6.35559 35.6444 5.83325 35 5.83325Z",
    fill: "#239A6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6042 34.8774C25.5842 34.8774 28 32.4616 28 29.4815C28 26.5015 25.5842 24.0857 22.6042 24.0857C19.6242 24.0857 17.2084 26.5015 17.2084 29.4815C17.2084 32.4616 19.6242 34.8774 22.6042 34.8774Z",
    fill: "#CFFCEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0809 30.3333H24.6226C23.9783 30.3333 23.4559 30.8556 23.4559 31.4999V39.9583C23.4559 40.6026 23.9783 41.1249 24.6226 41.1249H33.0809C33.7253 41.1249 34.2476 40.6026 34.2476 39.9583V31.4999C34.2476 30.8556 33.7253 30.3333 33.0809 30.3333Z",
    fill: "#9EEED3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5351 25.3283L30.0767 19.6408C29.6888 19.3812 29.1667 19.6583 29.1667 20.1249V31.497C29.1667 31.9637 29.6888 32.2408 30.0767 31.9812L38.5351 26.2937C38.8792 26.0633 38.8792 25.5558 38.5351 25.3254V25.3283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTestAcca);
export default __webpack_public_path__ + "static/media/icon_test_acca.d6f37bab.svg";
export { ForwardRef as ReactComponent };